import axios from 'axios';

/**
 * @constant users
 * @description Instancia de Axios para consumir la API de usuarios.
 * Utiliza la variable de entorno `REACT_APP_USERS_API` para definir la base URL.
 */
export const users = axios.create({
	baseURL: process.env.REACT_APP_USERS_API
});

/**
 * @constant colleges
 * @description Instancia de Axios para consumir la API de colegios.
 * Utiliza la variable de entorno `REACT_APP_COLLEGES_API` para definir la base URL.
 */
export const colleges = axios.create({
	baseURL: process.env.REACT_APP_COLLEGES_API
});

/**
 * @constant certifications
 * @description Instancia de Axios para consumir la API de certificaciones.
 * Utiliza la variable de entorno `REACT_APP_CERTIFICATIONS_API` para definir la base URL.
 */
export const certifications = axios.create({
	baseURL: process.env.REACT_APP_CERTIFICATIONS_API
});

/**
 * @constant files
 * @description Instancia de Axios para consumir la API de archivos.
 * Utiliza la variable de entorno `REACT_APP_FILES_API` para definir la base URL.
 */
export const files = axios.create({
	baseURL: process.env.REACT_APP_FILES_API
});